import React from 'react';
import {Button, notification} from 'antd';

// A tab open since before a deploy keeps running the old build (the owner, 02.11, still saw the filters of 30.10 cut
// short): every few minutes, and when the tab is shown again, the page's main script is compared with the server's;
// a new one brings a notice with «Обновить».
const MAIN = /\/static\/js\/main\.[0-9a-f]+\.chunk\.js/;
const EVERY_MS = 5 * 60 * 1000;

const loadedMain = () => {
  const script = [...document.querySelectorAll('script[src]')].find((s) => MAIN.test(s.getAttribute('src')));
  return script ? script.getAttribute('src').match(MAIN)[0] : null;
};

export const watchNewVersion = () => {
  const current = loadedMain();
  // a development build has no such script
  if (!current) return () => {};
  let shown = false;
  const check = async () => {
    if (shown || document.visibilityState !== 'visible') return;
    try {
      const response = await fetch('/', {cache: 'no-store'});
      const found = (await response.text()).match(MAIN);
      if (!found || found[0] === current) return;
      shown = true;
      notification.info({
        key: 'new-version',
        message: 'Админка обновилась',
        description: 'Обновите страницу, чтобы работать в новой версии.',
        duration: 0,
        btn: <Button type='primary' size='small' onClick={() => window.location.reload()}>Обновить</Button>,
      });
    } catch (error) {
      // offline: the next check tries again
    }
  };
  const timer = setInterval(check, EVERY_MS);
  document.addEventListener('visibilitychange', check);
  return () => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', check);
  };
};
